import { appConfig } from '@/config'

export default {
    computed: {
        tooltipDelay() {
            return appConfig.common.tooltipDelay
        }
    }
}
